"use client";

import useSWR from "swr";

interface GeoResponse {
  country: string | null;
  isVietnam: boolean;
}

interface IpResponse {
  ip: string | null;
  source: "request" | "dev-fallback" | null;
}

async function fetchGeo(): Promise<GeoResponse> {
  const geoRes = await fetch("/api/geo", { cache: "no-store" });
  if (!geoRes.ok) throw new Error("Failed to resolve geolocation");

  const geo = (await geoRes.json()) as GeoResponse;
  if (geo.country) return geo;

  const ipRes = await fetch("/api/ip", { cache: "no-store" });
  if (!ipRes.ok) return geo;

  const { ip } = (await ipRes.json()) as IpResponse;
  if (!ip) return geo;

  const geoWithIpRes = await fetch(`/api/geo?ip=${encodeURIComponent(ip)}`, {
    cache: "no-store",
  });
  if (!geoWithIpRes.ok) return geo;

  return geoWithIpRes.json();
}

export function useIsVietnam() {
  const {
    data: geo,
    isLoading,
    error,
  } = useSWR<GeoResponse>("pricing-geo", fetchGeo, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    shouldRetryOnError: false,
  });

  return {
    isVietnam: geo?.isVietnam ?? false,
    country: geo?.country ?? null,
    isLoading,
    error,
  };
}
